/** @jsx builderX.jsx */
import { builderX, Sprite, Image, MovieClip } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='loader'>
    <Image position={[632, -340]} scale={[2, 2]} src='preloader_bg_shine'/>
    <MovieClip position={[1092, 468]} scale={[0.84, 0.84]} name='slides'>
        <MovieClip position={[25, -16]} name='randomWilds'>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
            <Image src='help_page'/>
        </MovieClip>
        <MovieClip position={[25, -16]} name='freeGamesPick'>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
            <Image src='help_page_2_en'/>
        </MovieClip>
    </MovieClip>
    <MovieClip position={[1920, 1350]} name='textSlides'>
        <Sprite name='1'>
            <Sprite position={[0, 38]} name='text'/>
        </Sprite>
        <Sprite name='2'>
            <Sprite position={[0, 38]} name='text'/>
        </Sprite>
    </MovieClip>
    <Image position={[1220, 148]} scale={[0.55, 0.55]} src='wolf_haven_line_en'/>
</Sprite>;
